import { BuildVersion, IEnvironment } from './environment.interface';
import buildVersion from '@env/buildVersion';

//const apiUrl = 'https://localhost:13301';
const apiUrl = 'https://api-dmepos.portaldev.mynexuscare.com';
const platformApiUrl = 'https://api-platform.portaldev.mynexuscare.com';
const webpackPublicPath = 'http://localhost:4200'
const portalSupportLink = 'https://app.smartsheet.com/b/form/3511b90b2c4c4aa383763192c667aba6';

export const environment: IEnvironment = {
  production: false,
  apiUrl,
  platformApiUrl,
  modules: [],
  routes: [],
  version: buildVersion as BuildVersion,
  webpackPublicPath,
  portalSupportLink
};
